export enum ModulesStatesEnum {
  UNFOLDED = "unfolded",
  FOLDED = "folded",
  IN_PROGRESS = "inProgress",
  UNDER_MAINTENANCE = "underMaintenance",
  FAULTY = "faulty",
  UP = "up",
  LOCKED = "locked",
}
